import React, {useEffect} from 'react'
import * as ReactBootstrap from 'react-bootstrap'
import { connect, useDispatch, useSelector } from 'react-redux'
import {reset } from 'redux-form'
import { getLists } from '../../../state/lists'
import { showErrorToast, showSuccessToast } from '../../../state/toasts'
import * as components from '../../../components'
import { Slider } from '../../../components'
import * as rest from '../../../services'
import {GSXInformation} from "./GSXInformation";
import {GSXInformationForm, GSXInformationFormName} from "./GSXInformationForm";





const GSXInformationList = ({ ticket, onTicketUpdate }) => {
  const dispatch = useDispatch()
  const { gsx_repair_type ,coverage_type} = useSelector((state) => state.lists)
  const loadOptions = () => {
    !gsx_repair_type && dispatch(getLists('GSX_REPAIR_TYPE'))
    !coverage_type && dispatch(getLists('COVERAGE_TYPE'))
  }

  useEffect(() => {
      loadOptions()
  },[])

  const createGSXInformation = (values) => {
    values.ticket = ticket.url
    new rest.GSXInfoService()
      .makePostRequest(values)
      .then((response) => {
        onTicketUpdate({...ticket,gsx_information:[response,...ticket.gsx_information]})
        dispatch(reset(GSXInformationFormName))
        dispatch(
          showSuccessToast('Success', `Ticket GSX Information has been saved.`)
        )
      })
      .catch((errors) => {
        dispatch(showErrorToast('Error', errors.response.data))
      })
  }
  const GSXInformationFormWithData = connect((state) => ({
    initialValues: {
      gsx_service_type: ticket.device.gsx_service_type,
    },
  }))(GSXInformationForm)
  return (
    <ReactBootstrap.Card className="mt-5">
      <ReactBootstrap.Card.Title className="card-header bg-dark text-white card-header">
        <ReactBootstrap.Row>
          <ReactBootstrap.Col xs="6"> GSX Information</ReactBootstrap.Col>
          <ReactBootstrap.Col className="text-end" xs="6">
            <Slider
              onAfterOpen={loadOptions}
              title={components.ICONS.PLUS}
              header={
                <>
                  <span className="mr-3">{components.ICONS.PLUS}</span>
                  <span>Add GSX Repair Information</span>
                </>
              }
            >
              <GSXInformationFormWithData
                gsx_repair_types={gsx_repair_type}
                gsx_service_types={coverage_type}
                onSubmit={createGSXInformation}
              />
            </Slider>
          </ReactBootstrap.Col>
        </ReactBootstrap.Row>
      </ReactBootstrap.Card.Title>

      <ReactBootstrap.Card.Body>
        {ticket.gsx_information.length && gsx_repair_type && coverage_type? (
          <components.ItemList
            itemRenderer={(index, key) => {
              return (
                <ReactBootstrap.Col
                  xs="12"
                  key={ticket.gsx_information[index].url}
                >
                  <GSXInformation
                    ticket={ticket}
                    information={ticket.gsx_information[index]}
                    onTicketUpdate={onTicketUpdate}
                    gsx_repair_types={gsx_repair_type}
                    gsx_service_types={coverage_type}
                  />
                </ReactBootstrap.Col>
              )
            }}
            length={ticket.gsx_information.length}
          />
        ) : (
          <ReactBootstrap.Alert variant={'info'}>
            No previous GSX information found.
          </ReactBootstrap.Alert>
        )}
      </ReactBootstrap.Card.Body>
    </ReactBootstrap.Card>
  )
}

export default GSXInformationList
